"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * This is exported as a separate function so that we can mock it.
 * @alias isOnServer
 * @internal
 */
var _default = function _default() {
  return typeof window === 'undefined';
};

exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pc09uU2VydmVyLnRzIl0sIm5hbWVzIjpbIndpbmRvdyJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7ZUFDZTtBQUFBLFNBQWUsT0FBT0EsTUFBUCxLQUFrQixXQUFqQztBQUFBLEMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIFRoaXMgaXMgZXhwb3J0ZWQgYXMgYSBzZXBhcmF0ZSBmdW5jdGlvbiBzbyB0aGF0IHdlIGNhbiBtb2NrIGl0LlxuICogQGFsaWFzIGlzT25TZXJ2ZXJcbiAqIEBpbnRlcm5hbFxuICovXG5leHBvcnQgZGVmYXVsdCAoKTogYm9vbGVhbiA9PiB0eXBlb2Ygd2luZG93ID09PSAndW5kZWZpbmVkJztcbiJdfQ==